package xim.poc.game.configuration.v0.tactics

import xim.poc.audio.AudioManager
import xim.poc.audio.SystemSound
import xim.poc.game.*
import xim.poc.game.configuration.v0.tactics.behaviors.TacticsBehaviorController

class TacticsSummonContext(val ui: TacticsUi): TacticsUiContext {

    override fun onActivated() {
    }

    override fun handleEnter() {
        val cursorPosition = ui.match.cursorPosition
        if (cursorPosition is PlayerPrepPosition) {
            returnToTower(SystemSound.MenuSelect)
            return
        }

        if (TacticsMatchInstance.towerSummonPositions.contains(cursorPosition) && ui.match.getUnit(cursorPosition) == null) {
            TacticsSummonSelectUi(ui).push()
            AudioManager.playSystemSoundEffect(SystemSound.TargetConfirm)
            return
        }

        val unit = ui.match.getHighlightedUnit() ?: return

        if (unit.type == ActorType.Enemy) {
            AudioManager.playSystemSoundEffect(SystemSound.MenuSelect)
            ui.activateContext(TacticsSetupSkillViewer(ui, unit))
            return
        }

        val manageOptions = ArrayList<QueryMenuOption>()
        if (TacticsState.hasUnlockedInheritance()) {
            manageOptions += QueryMenuOption("Manage inheritance", 2)
        }

        manageOptions += listOf(
            QueryMenuOption("Release", 1),
            QueryMenuOption("Cancel", -1)
        )

        val preview = TacticsUnitSkillPreview(unit.getUnit())

        UiStateHelper.openQueryMode(
            promptProvider =  { "What will you do?" },
            optionsProvider = { manageOptions },
            childStates = { listOf(preview.skillPreview) },
            keyHandler = { skillPreviewKeyHandler(preview.skillPreview) },
            enableCursorMovementKeys = true,
            drawFn = {
                ui.draw()
                TacticsUnitDescription.drawUnitDescription(unit.getUnit(), unit.type, state = unit)
            },
        ) { handleManageChoice(it, unit) }

    }

    override fun handleExit() {
        returnToTower(SystemSound.MenuClose)
    }

    override fun applyPanelHighlights() {
        TacticsMatchInstance.towerSummonPositions.map { toZonePanel(it) }.forEach { it.mask = ui.highlight(Highlight.aquaHighlight) }
    }

    override fun isBoardOnly(): Boolean {
        return false
    }

    private fun handleManageChoice(queryMenuOption: QueryMenuOption?, unit: ActorState): QueryMenuResponse {
        (unit.behaviorController as? TacticsBehaviorController)?.recomputeSkills()
        if (queryMenuOption == null || queryMenuOption.value < 0) { return QueryMenuResponse.pop }

        if (queryMenuOption.value == 1) {
            ui.match.releasePlayerUnit(unit)
        } else if (queryMenuOption.value == 2) {
            TacticsInheritanceUi(unit.getUnit()).push()
            return QueryMenuResponse.noop(SystemSound.MenuSelect)
        }

        return QueryMenuResponse.pop
    }

    private fun returnToTower(systemSound: SystemSound) {
        ui.match.setCursor(PlayerPrepPosition)
        ui.activateContext(TacticsTowerContext(ui))
        AudioManager.playSystemSoundEffect(systemSound)
    }

}

class TacticsSetupSkillViewer(val ui: TacticsUi, val unit: ActorState): TacticsUiContext {

    private val subUi = TacticsSkillSelectUi(this, ui.match, unit)

    override fun onActivated() {
        subUi.push()
    }

    override fun handleEnter() {
    }

    override fun handleExit() {
        ui.activateContext(TacticsSummonContext(ui))
    }

    override fun applyPanelHighlights() {
        TacticsSkillSelectHighlighter.applyPanelHighlights(ui, subUi, unit)
    }

}